<template>
    <router-link class="client-card" :to="link">
        <Card is-clickable>
            <div class="client-card__logo-container">
                <img v-if="logo" class="client-card__logo" :src="logo" />
                <Icon v-else type="ios-image-outline" class="client-card__missing-logo" />
            </div>

            <template #title>
                {{ name }}
            </template>

            <template v-if="$auth.hasScope({ clientId: id })" #actionItems>
                <Dropdown trigger="click" class="client-card__options">
                    <CardFooterButton>
                        <Icon type="ios-more" class="client-card-option--dots" data-testid="client_more-options" />
                    </CardFooterButton>

                    <template #list>
                        <DropdownMenu>
                            <DropdownItem
                                v-if="$auth.userCan($auth.Actions.CanEditClient, { clientId: id })"
                                class="client-card-option--edit"
                                data-testid="client_edit-button"
                                @click.prevent="$emit('edit')"
                            >
                                Edit
                            </DropdownItem>
                            <DropdownItem
                                class="client-card-option--manage"
                                data-testid="client_team-button"
                                @click.prevent="$emit('manage-team')"
                            >
                                Manage Team
                            </DropdownItem>
                        </DropdownMenu>
                    </template>
                </Dropdown>
            </template>
        </Card>
    </router-link>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import Card from "@/components/Card/Card.vue";
import CardFooterButton from "@/components/Card/CardFooterButton.vue";
import { AppRouteNames } from "@/router/constants";

export default defineComponent({
    components: {
        Card,
        CardFooterButton
    },

    props: {
        id: {
            type: String,
            required: true
        },
        logo: {
            type: String
        },
        name: {
            required: true,
            type: String
        }
    },

    emits: ["edit", "manage-team"],

    computed: {
        link() {
            return {
                name: AppRouteNames.CLIENT_CAMPAIGNS,
                params: { clientId: this.id }
            };
        }
    }
});
</script>

<style lang="scss">
@use "@style/variables" as *;

$logo-height: 200px;

.client-card__logo {
    max-height: 75%;
    max-width: 75%;
    flex: 0 0 auto;
}

.client-card__logo-container {
    align-items: center;
    color: $grey5;
    display: flex;
    height: $logo-height;
    justify-content: center;
}

.client-card__missing-logo {
    align-items: center;
    display: flex;
    height: $logo-height;
    font-size: 80px;
    justify-content: center;
}
</style>
